export default "/images/82d69edbe1363867a756cc584a36f89a.avif";